import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'info';

interface Notification {
    id: string;
    message: string;
    type: NotificationType;
    duration?: number;
}

interface NotificationStore {
    notifications: Notification[];
    addNotification: (message: string, type: NotificationType, duration?: number) => void;
    removeNotification: (id: string) => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
    notifications: [],
    addNotification: (message, type, duration = 4000) => {
        const id = Math.random().toString(36).substring(2, 9);
        set((state) => ({
            notifications: [...state.notifications, { id, message, type, duration }]
        }));

        if (duration !== Infinity) {
            setTimeout(() => {
                set((state) => ({
                    notifications: state.notifications.filter((n) => n.id !== id)
                }));
            }, duration);
        }
    },
    removeNotification: (id) => set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id)
    })),
}));

// Convenience helpers
export const toast = {
    success: (message: string, duration?: number) =>
        useNotificationStore.getState().addNotification(message, 'success', duration),
    error: (message: string, duration?: number) =>
        useNotificationStore.getState().addNotification(message, 'error', duration),
    info: (message: string, duration?: number) =>
        useNotificationStore.getState().addNotification(message, 'info', duration),
};
